import { FC } from "react";

import styles from "./InsightsPreview.module.scss";

export const InsightsPreview: FC<Widget.PreviewProps> = ({ view }) => (
  <div className={styles.widgetPreview}>
    <div className={styles.chartWrapper}>{view?.chart}</div>
  </div>
);
